<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="150">
                <FormItem :label="$t('cname')">
                    <Input v-model="org_cname" disabled></Input>
                </FormItem>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('start_date')">
                            <DatePicker class='fillw' :editable="false" type='date' v-model="formData.start_date"></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row v-if="item.org_level == '3'">
                    <Col span="12">
                        <FormItem :label="$t('org_grade')" prop="org_grade">
                            <Select v-model="formData.org_grade" :placeholder="$t('select')">
                                <Option :value="item.key" v-for="item in org_grade" :key="item.key">{{item.value}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('status')" prop="org_status">
                            <RadioGroup :key="index" v-model="formData.org_status" v-for="(item, index) in org_status">
                                <Radio :label="item.key">{{item.value}}</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
<!--                <Row>-->
<!--                    <Col span="12"><FormItem :label="$t('add_user')"><Input v-model="formData.add_user" disabled></Input></FormItem></Col>-->
<!--                    <Col span="12"><FormItem :label="$t('add_time')"><Input v-model="formData.add_time" disabled></Input></FormItem></Col>-->
<!--                </Row>-->
<!--                <Row>-->
<!--                    <Col span="12"><FormItem :label="$t('upd_user')"><Input v-model="formData.upd_user" disabled></Input></FormItem></Col>-->
<!--                    <Col span="12"><FormItem :label="$t('upd_time')"><Input v-model="formData.upd_time" disabled></Input></FormItem></Col>-->
<!--                </Row>-->
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                relist: false,
                org_cname: '',
                org_level: '',
                formData: {
                    org_id:'',
                    start_date:'',
                    org_grade: '',
                    org_status: '',
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                rule: {
                    org_grade: [{required: true, message: this.$t('input'), trigger: 'select'}],
                    org_status: [{required: true, message: this.$t('input'), trigger: 'change'}],
                },
                item: {},
                org_grade: [],
                org_status: []
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.item = JSON.parse(this.$base.getRequest().data);
            this.formData.org_id = this.item.org_id;
            this.getInfo();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                this.$base.showLoading();
                this.$request.sendPost("org-down-s0/before-setup-high",{org_id: this.item.org_id},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.org_grade = this.org_grade.concat(data.org_grade);
                        this.org_status = this.org_status.concat(data.org_status);
                        this.org_cname = this.item.org_cname;
                        this.org_level = this.item.org_level;
                        this.formData.org_grade = this.item.org_grade;
                        this.formData.org_status = this.item.org_status;
                        this.formData.start_date = this.item.start_date;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                var url = 'org-down-s0/setupHigh';
                this.$base.showLoading();
                this.$request.sendPost(url,this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.alertSuccess(error.errmsg);
                        this.relist = true;
                        this.$base.linkBack();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });

            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/down/downs0_higset.vue